import React from 'react';
import logo from '../assets/images/Logo_Ambitus.png';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

function Boards() {
  const { t } = useTranslation();

  return (
    <main className="boards-page">
      <div className="boards-glow boards-glow-left" />
      <div className="boards-glow boards-glow-right" />
      <LanguageSwitcher className="boards-language-switcher" />

      <section className="boards-card" aria-labelledby="boards-title">
        <a className="boards-brand" href="/" aria-label={t('boards.homeLabel')}>
          <img src={logo} alt="" />
          <span>Ambitus Strategy</span>
        </a>

        <div className="boards-status">{t('boards.status')}</div>
        <h1 id="boards-title">{t('boards.title')}</h1>
        <p>{t('boards.description')}</p>

        <a className="boards-home-link" href="/">
          {t('boards.backHome')}
        </a>
      </section>
    </main>
  );
}

export default Boards;
